import axios from "axios";

const baseUrl = axios.create({
  baseURL: "https://api.gufoon-optix.com/",
});

export default baseUrl;
